import { on } from 'delegated-events'
import debounce from 'lodash/debounce'
import { slideToggle } from '../common/slide'

let windowWidth = window.innerWidth

const fn = {
  init: () => {
    on('click', '[data-toggle-faq]', fn.handleToggle)
    on('keyup', '[data-toggle-faq]', fn.handleToggle)

    on('click', '[data-expand-faq]', fn.handleExpand)

    fn.setHeights(true)

    window.addEventListener('resize', debounce(fn.setHeights, 100))
  },

  handleToggle: (e) => {
    if (e.type === 'keyup' && e.keyCode !== 13) {
      return
    }

    const trigger = e.target.closest('[data-toggle-faq]')

    if (!trigger) {
      return
    }

    const target = document.getElementById(trigger.getAttribute('aria-controls'))

    if (!target) {
      return
    }

    document.querySelectorAll('[data-toggle-faq]').forEach((el) => {
      el.parentNode.parentNode.style.height = null
    })

    if (trigger.getAttribute('aria-expanded') === 'false') {
      fn.closeOthers()

      trigger.parentNode.parentNode.style.height = null
      trigger.style.height = `${trigger.parentNode.parentNode.offsetHeight}px`

      slideToggle(target)

      trigger.setAttribute('aria-expanded', 'true')
    } else {
      slideToggle(target).then(() => {
        trigger.style.height = null
      })

      trigger.setAttribute('aria-expanded', 'false')
    }
  },

  handleExpand: (e) => {
    const trigger = e.target.closest('[data-expand-faq]')
    const parent = trigger.closest('.faq-item')
    const container = parent.querySelector('.faq-container')

    if (trigger.getAttribute('aria-expanded') === 'false') {
      fn.closeOthers()

      container.style.height = `${trigger.offsetHeight}px`
      container.classList.add('is-expanded')
      trigger.setAttribute('aria-expanded', 'true')
    } else {
      container.style.height = null
      container.classList.remove('is-expanded')
      trigger.setAttribute('aria-expanded', 'false')
    }
  },

  closeOthers: () => {
    document.querySelectorAll('[data-toggle-faq][aria-expanded="true"]').forEach((el) => {
      const target = document.getElementById(el.getAttribute('aria-controls'))

      slideToggle(target).then(() => {
        el.style.height = null
        el.setAttribute('aria-expanded', 'false')
      })
    })

    document.querySelectorAll('[data-expand-faq][aria-expanded="true"]').forEach((el) => {
      const trigger = el.closest('[data-expand-faq]')
      const parent = trigger.closest('.faq-item')
      const container = parent.querySelector('.faq-container')

      container.style.height = null
      container.classList.remove('is-expanded')
      trigger.setAttribute('aria-expanded', 'false')
    })
  },

  setHeights: (force = false) => {
    if (window.innerWidth != windowWidth || force === true) {
      document.querySelectorAll('[data-toggle-faq]').forEach((el) => {
        const parent = el.closest('.faq-item')
        const parentStyle = getComputedStyle(parent)
        const height =
          parent.offsetHeight - (parseFloat(parentStyle.paddingTop) + parseFloat(parentStyle.paddingBottom)) - 4

        if (window.matchMedia('(min-width: 768px)').matches) {
          el.style.minHeight = `${height}px`
        } else {
          el.style.minHeight = null
        }
      })

      document.querySelectorAll('[data-expand-faq]').forEach((el) => {
        const parent = el.closest('.faq-item')
        const container = parent.querySelector('.faq-container')
        const parentStyle = getComputedStyle(parent)
        const height =
          parent.offsetHeight - (parseFloat(parentStyle.paddingTop) + parseFloat(parentStyle.paddingBottom))

        if (window.matchMedia('(min-width: 768px)').matches) {
          container.style.minHeight = `${height}px`
        } else {
          container.style.minHeight = null
        }
      })

      windowWidth = window.innerWidth
    }
  },
}

export default {
  can: () => true,
  run: fn.init,
}
